import BaseService from '@/features/BaseService';

export default class EventService extends BaseService {

  constructor() {
    super('events');
  }

}



// WEBPACK FOOTER //
// ./src/features/event/EventService.js